/* Festive offer: cart progress bar + "total with offer" (cart drawer and cart page),
   and the offer tag on the main product image.
   Cart content comes from sections/offer-cart-bar.liquid (which renders snippets/offer-festive.liquid). */
(function () {
  if (window.__oydOfferBar) return;
  window.__oydOfferBar = true;

  var SECTION = 'offer-cart-bar';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var barHtml = '';
  var totalHtml = '';
  var timer = null;

  function ensureSlot(anchor, className, where) {
    var parent = anchor.parentNode;
    var slot = parent.querySelector(':scope > .' + className);
    if (!slot) {
      slot = document.createElement('div');
      slot.className = className;
      if (where === 'before') parent.insertBefore(slot, anchor);
      else anchor.insertAdjacentElement('afterend', slot);
    }
    return slot;
  }

  function fill(slot, content) {
    if (slot.innerHTML !== content) slot.innerHTML = content;
  }

  function place() {
    // Progress bar: under the drawer header, and above the cart page items
    var header = document.querySelector('#CartDrawer .drawer__header');
    if (header) fill(ensureSlot(header, 'oyd-offer-slot', 'after'), barHtml);

    var cartForm = document.querySelector('cart-items form#cart');
    if (cartForm) fill(ensureSlot(cartForm, 'cart-items-offer-slot', 'before'), barHtml);

    // Total with offer: right under the theme's "Estimated total"
    document.querySelectorAll('#CartDrawer .totals, .cart__footer .totals').forEach(function (totals) {
      fill(ensureSlot(totals, 'oyd-offer-total-slot', 'after'), totalHtml);
    });
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var doc = new DOMParser().parseFromString((data && data[SECTION]) || '', 'text/html');
          var bar = doc.querySelector('[data-oyd-part="bar"]');
          var total = doc.querySelector('[data-oyd-part="total"]');
          barHtml = bar ? bar.innerHTML : '';
          totalHtml = total ? total.innerHTML : '';
          place();
        })
        .catch(function () {});
    }, 150);
  }

  // Refresh whenever the cart changes (add, quantity change, remove).
  var originalFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = originalFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(refresh, function () {});
    }
    return p;
  };

  // Product page: copy the offer tag (rendered next to the price) onto the first product photo.
  function placeImageTags() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.querySelector('.oyd-offer-tag')) return;
      var scope = gallery.closest('.product') || document;
      var tpl = scope.querySelector('template.oyd-offer-image-tag');
      if (!tpl) return;
      // Put it inside the first product photo so it lines up with the image on every screen size.
      var target = gallery.querySelector('.product__media-item .product-media-container') || gallery;
      target.appendChild(tpl.content.cloneNode(true));
    });
  }

  // The theme re-renders parts of the page (drawer, cart footer, variant changes);
  // put our pieces back if they disappear.
  function watchPage() {
    if (!window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        placeImageTags();
        if (barHtml || totalHtml) place();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    placeImageTags();
    watchPage();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
